<template>
  <div>
    <div v-if="details">
      <div v-if="!editing">
        <h3 v-if="details.name">{{ details.name }}</h3>
        <p v-if="error_message">{{ error_message }}</p>
        <p v-if="details.description">{{ details.description }}</p>
        <p v-if="details.author">Av: {{ details.author }}</p>
        <p v-if="details.portions">Porsjoner: {{ details.portions }}</p>
        <h5>
          Ingredienser
          <span v-if="details.portions">
            til {{ details.portions }} porsjon<span v-if="details.portions > 1"
              >er</span
            ></span
          >:
        </h5>
        <ul
          class="list-unstyled"
          v-if="details.ingredients"
          id="ingredientList"
        >
          <li v-for="(ing, index) in details.ingredients" :key="index">
            {{ ing.amount + " " + ing.unit + " " + ing.name }}
          </li>
        </ul>
        <p v-if="details.directions">{{ details.directions }}</p>
        <button
          v-if="this.$session.has('token')"
          class="btn btn-secondary"
          @click="editing = !editing"
        >
          Endre oppskrift
        </button>
        <!--router-link
        v-if="this.$session.exists('token')"
        :to="this.$route.path + '/edit'"
        >Endre oppskrift</router-link
      --></div>
      <div v-else>
        <editReciepeForm
          @posted="loadReciepe"
          :data="details"
        ></editReciepeForm>
      </div>
    </div>
  </div>
</template>
<script>
import editReciepeForm from "@/components/editReciepeForm.vue";
export default {
  name: "reciepeDetails",
  props: {
    reciepe_id: {
      type: Number,
      required: true
    }
  },
  data: function() {
    return {
      details: null,
      error_message: "",
      editing: false
    };
  },
  components: {
    editReciepeForm
  },
  methods: {
    loadReciepe() {
      this.APIget("reciepes/" + this.$props.reciepe_id + "/?format=json").then(
        response => {
          if (response.error) {
            this.error_message =
              "Error occured while retrieving reciepe" + response.error;
            return;
          }
          this.details = response.data;
        }
      );
      this.editing = false;
    }
  },
  created() {
    this.loadReciepe();
  }
};
</script>
<style></style>
